module.exports = __webpack_public_path__ + "img/Skirt-Front-B4-Db-Fc-Gb-Hc-Ia.ae089cbd.png";